const customPhoneLabelStyle = {
	customPhoneLabelWrapper: {
		pointerEvents: 'none',
	},

};

export default customPhoneLabelStyle;
